// generated from 12 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const deviceGaidFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("device_gaid_filter"),
  comparison_key: z.enum([
    "11", // 6 (50.00%)
    "1", // 5 (41.67%)
    "12", // 1 (8.33%)
  ]),
  display_name: z.string(),
  // undefined: 6 (50.00%), defined 6 (50.00%)
  // format uuid: 2 (33.33%)
  raw_value: z.string().optional(),
  // format integer: 3 (25.00%)
  value: z.string(),
  varies_by_app_group: z.literal(false),
});
